import { useEffect, useState } from "react";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    const toggleChangeColor = () => {
      if (window.scrollY > 3400) {
        setIsBottom(true);
      } else {
        setIsBottom(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("scroll", toggleChangeColor);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("scroll", toggleChangeColor);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="fixed bottom-4 left-1/2 z-[999]">
      <div className="flex items-center gap-2.5">
        {isVisible && (
          <div
            onClick={scrollToTop}
            aria-label="scroll to top"
            className="flex cursor-pointer items-center justify-center transition duration-300 ease-in-out rounded-1xl"
          >
            <img
              src={
                isBottom
                  ? "/images/Icon/arrow-light.png"
                  : "/images/Icon/arrow-dark.png"
              }
              alt="Images"
              className="
                w-[20px] h-[20px] 
                sm:w-[20px] sm:h-[20px]   <!-- ~375-640px -->
                md:w-[25px] md:h-[25px]   <!-- ~768px -->
                lg:w-[30px] lg:h-[30px]   <!-- ~1024px -->
                xl:w-[30px] xl:h-[30px]   <!-- ~1280px et plus -->
                2xl:w-[40px] 2xl:h-[40px] object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ScrollToTop;
